import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewCustomer = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/customer/add?`, data);
  return res.data;
};

export const getAllCustomers = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/customer?user_id=${data.user_id}&user_type=${data.user_type}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};

export const getAllverificationCustomers = async (data) => {
  const customerData = JSON.parse(sessionStorage.getItem("info"));
  const res = await axios.get(
    `${API_BASE_URL}/customer?user_id=${customerData.id}&user_type=${customerData.type}&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const updateCustomersById = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=customer&id=${id}`,
    data
  );
  return res.data;
};
export const getCustomersById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/customer/${id}`);
  return res.data;
};
export const getCustomersLoansById = async (id) => {
  const res = await axios.get(
    `${API_BASE_URL}/loans/byCustomerId?customer_id=${id}`
  );
  return res.data;
};
export const searchLoansByCustomerDetails = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/customer/customer_aadhar_loan_number?key=${data}`
  );
  return res.data;
};
export const updateCustomersLoansById = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/common?table=loans&id=${id}`,
    data
  );
  return res.data;
};
export const updatePaymentById = async (id, data) => {
  const res = await axios.patch(
    `${API_BASE_URL}/emi_details/update?customer_id=${id}`,
    data
  );
  return res.data;
};

export const updateBankDetails = async (data) => {
  const res = await axios.patch(`${API_BASE_URL}/customer/bankDetails`, data);
  return res.data;
};

export const updateVerificationById = async (data) => {
  const res = await axios.patch(`${API_BASE_URL}/emi_details/update`, data);
  return res.data;
};
export const getCibilReport = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/customer/cibil-record`, data);
  return res.data;
};

export const emandateRegistration = async (data) => {
  const res = await axios.post(
    `${API_BASE_URL}/customer/register-emandate`,
    data
  );
  return res.data;
};

export const saveAutoDebitEmi = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/customer/save-mandate`, data);
  return res.data;
};

export const autoDebitEmiPayment = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/customer/auto-debit`, data);
  return res.data;
};
